<template>
  <div class="cell_cont">
    <!-- 订单商品列表 -->
    <el-table :data="dataList" highlight-current-row max-height="526" border>
      <el-table-column show-overflow-tooltip label="物料名称" width="100" prop="materialName"/>
      <el-table-column show-overflow-tooltip label="物料规格型号" width="100" prop="specification"/>
      <el-table-column show-overflow-tooltip label="产品名称" width="100" prop="productName"/>
      <el-table-column show-overflow-tooltip label="产品规格型号" width="100" prop="productSpecification"/>
      <el-table-column show-overflow-tooltip label="产品DI" prop="diCode"/>
      <el-table-column show-overflow-tooltip label="物料编码" prop="materialCode"/>
      <el-table-column prop="prodDate" label="生产日期" width="120">
        <template slot-scope="scope">
          {{ scope.row.prodDate ? formatDate(scope.row.prodDate, 'yyyy-MM-dd') : null }}
        </template>
      </el-table-column>
      <el-table-column prop="expiryDate" label="失效日期" width="120">
        <template slot-scope="scope">
          {{ scope.row.expiryDate ? formatDate(scope.row.expiryDate, 'yyyy-MM-dd') : null }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="批号" prop="batchNumber"/>
      <el-table-column show-overflow-tooltip label="入库仓库" prop="warehouseName"/>
      <el-table-column show-overflow-tooltip label="计划入库数" prop="number" width="90"/>
      <el-table-column show-overflow-tooltip label="实际入库数" prop="inNumber" width="90"/>
      <el-table-column show-overflow-tooltip label="包装层级" prop="packLevel"/>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="$btnsPermission('warehouse:queryUdi')" type="text" @click="handlePeview(scope.row)">查看UDI码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <warehoseUdiReview
      v-if="reviewVisible"
      :visible="reviewVisible"
      :dict-obj="dictObj"
      :state="detailInfo.state"
      :product-info="reviewData"
      @close="reviewVisible=false"/>
  </div>
</template>
<script>
import {getWarehousingOrderInfo} from '@/api/warehousingOrder'
import {formatDate} from '@/utils/date.js'
import warehoseUdiReview from "./warehoseUdiReview.vue";

export default {
  name: 'ProductList',
  components: {
    warehoseUdiReview
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dictObj:{
      type:Object,
      default:()=>{
        return {
          receiptDeliveryState:[]
        }
      }
    },
  },
  data() {
    return {
      // 订单商品列表数据
      dataList: [],
      reviewVisible: false, // 预览弹框是否显示
      detailInfo: {}, // 入库单数据
      reviewData: {}, // 预览数据
      formatDate
    }
  },
  methods: {
    // 获取单据信息
    open({id}) {
      // 获取基础信息数据
      this.$emit('changeParentLoading', true)
      getWarehousingOrderInfo(id).then(res => {
        this.detailInfo = res.data
        this.dataList = res.data.productList
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
    //   处理预览UDI
    handlePeview(row) {
      this.reviewData = row
      this.reviewVisible = true
    }
  }
}
</script>
